export const Year = {
  isValidNumber: (year: number) =>
    /^\d{0}$|^\d{4}$/.test(year.toString()),
  isValidString: (year: string) =>
    /^\d{0}$|^\d{4}$/.test(year),
}
